import { Pipe, PipeTransform } from '@angular/core';
import { INTERVAL } from '@univacity/shared/types';

@Pipe({
  name: 'interval',
  standalone: false,
})
export class IntervalPipe implements PipeTransform {
  transform(value: INTERVAL): string {
    const interval: { [key in string]: string } = {
      [INTERVAL.annually]: $localize`Per Year`,
      [INTERVAL.monthly]: $localize`Per Month`,
      [INTERVAL.perSemester]: $localize`Per Semester`,
      [INTERVAL.fullProgram]: $localize`Full Program`,
    };
    return interval[value];
  }
}
